import { ILocumData } from '../../models/directory/locum.model';

export const dummyLocums: ILocumData[] = [
  {
    id: '1',
    usersName: 'Dr. AdebayoOlu',
    firstName: 'Adebayo',
    lastName: 'Oluwaseun',
    email: 'adebayo.olu@example.com',
    phone: '+2348012345671',
    birthday: '1985-06-15',
    state: 'Lagos',
    country: 'Nigeria',
    yearsOfExperience: 3,
    occupation: 'Medical Doctor',
    bio: 'General practitioner with experience in family medicine.',
    profileImage: null,
    isVerified: true,
    verification: {
      id: 'v1',
      yearOfCurrentLicense: '2015',
      license: 'MDL/NG/2020/1234',
      primaryDegreeName: 'MBBS',
      primaryDegreeCertificate: 'degree-mbbs.pdf',
      validationNumber: 'VAL123456',
      status: 'verified',
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    },
    experiences: [
      {
        id: 'e1',
        title: 'Resident Doctor',
        companyName: 'LUTH',
        employmentType: 'Full-time',
        location: 'Lagos',
        otherQualification: 'Housemanship',
        qualificationCertificate: null,
        yearOfQualification: '2016',
        startDate: '2016-01-01',
        endDate: '2018-01-01',
      },
    ],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Gold',
    governmentIdStatus: 'verified',
    isAvailableForWork: true,
  },
  {
    id: '2',
    usersName: 'NgoziChukwu',
    firstName: 'Ngozi',
    lastName: 'Chukwu',
    email: 'ngozi.chukwu@example.com',
    phone: '+2348012345672',
    birthday: '1990-08-22',
    state: 'Enugu',
    country: 'Nigeria',
    yearsOfExperience: 7,
    occupation: 'Nurse',
    bio: 'Registered nurse with expertise in maternal and child health.',
    profileImage: null,
    isVerified: false,
    verification: null,
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Silver',
    governmentIdStatus: 'pending',
    isAvailableForWork: true,
  },
  {
    id: '3',
    usersName: 'HassanBello',
    firstName: 'Hassan',
    lastName: 'Bello',
    email: 'hassan.bello@example.com',
    phone: '+2348012345673',
    birthday: '1988-02-05',
    state: 'Kano',
    country: 'Nigeria',
    yearsOfExperience: 6,
    occupation: 'Pharmacist',
    bio: 'Licensed pharmacist with strong background in clinical pharmacy.',
    profileImage: null,
    isVerified: true,
    verification: {
      id: 'v3',
      yearOfCurrentLicense: '2012',
      license: 'PHAR/NG/2020/5678',
      primaryDegreeName: 'BPharm',
      primaryDegreeCertificate: 'degree-bpharm.pdf',
      validationNumber: 'VAL654321',
      status: 'verified',
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    },
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Platinum',
    governmentIdStatus: 'verified',
    isAvailableForWork: false,
  },
  {
    id: '4',
    usersName: 'FatimaUsman',
    firstName: 'Fatima',
    lastName: 'Usman',
    email: 'fatima.usman@example.com',
    phone: '+2348012345674',
    birthday: '1992-03-14',
    state: 'Kaduna',
    country: 'Nigeria',
    yearsOfExperience: 5,
    occupation: 'Midwife',
    bio: 'Compassionate midwife specializing in safe deliveries.',
    profileImage: null,
    isVerified: false,
    verification: null,
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Bronze',
    governmentIdStatus: 'pending',
    isAvailableForWork: true,
  },
  {
    id: '5',
    usersName: 'EmekaOkoro',
    firstName: 'Emeka',
    lastName: 'Okoro',
    email: 'emeka.okoro@example.com',
    phone: '+2348012345675',
    birthday: '1987-10-10',
    state: 'Anambra',
    country: 'Nigeria',
    yearsOfExperience: 9,
    occupation: 'Medical laboratory scientist',
    bio: 'Experienced in diagnostic testing and lab analysis.',
    profileImage: null,
    isVerified: true,
    verification: {
      id: 'v5',
      yearOfCurrentLicense: '2014',
      license: 'MLS/NG/2020/7789',
      primaryDegreeName: 'BMLS',
      primaryDegreeCertificate: 'degree-bmls.pdf',
      validationNumber: 'VAL778899',
      status: 'verified',
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    },
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Gold',
    governmentIdStatus: 'verified',
    isAvailableForWork: true,
  },
  {
    id: '6',
    usersName: 'IfeomaEze',
    firstName: 'Ifeoma',
    lastName: 'Eze',
    email: 'ifeoma.eze@example.com',
    phone: '+2348012345676',
    birthday: '1993-09-07',
    state: 'Abia',
    country: 'Nigeria',
    yearsOfExperience: 4,
    occupation: 'Occupational therapist',
    bio: 'Therapist supporting patients in regaining independence.',
    profileImage: null,
    isVerified: false,
    verification: null,
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Silver',
    governmentIdStatus: 'pending',
    isAvailableForWork: false,
  },
  {
    id: '7',
    usersName: 'TundeAdeyemi',
    firstName: 'Tunde',
    lastName: 'Adeyemi',
    email: 'tunde.adeyemi@example.com',
    phone: '+2348012345677',
    birthday: '1989-11-19',
    state: 'Oyo',
    country: 'Nigeria',
    yearsOfExperience: 4,
    occupation: 'Physiotherapist',
    bio: 'Physiotherapist with experience in sports injuries and rehabilitation.',
    profileImage: null,
    isVerified: true,
    verification: {
      id: 'v7',
      yearOfCurrentLicense: '2011',
      license: 'PT/NG/2020/4455',
      primaryDegreeName: 'BPT',
      primaryDegreeCertificate: 'degree-bpt.pdf',
      validationNumber: 'VAL445566',
      status: 'verified',
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    },
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Platinum',
    governmentIdStatus: 'verified',
    isAvailableForWork: true,
  },
  {
    id: '8',
    usersName: 'GraceIbrahim',
    firstName: 'Grace',
    lastName: 'Ibrahim',
    email: 'grace.ibrahim@example.com',
    phone: '+2348012345678',
    birthday: '1995-01-12',
    state: 'Plateau',
    country: 'Nigeria',
    yearsOfExperience: 3,
    occupation: 'Speech therapist',
    bio: 'Helping children and adults improve communication skills.',
    profileImage: null,
    isVerified: false,
    verification: null,
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Bronze',
    governmentIdStatus: 'pending',
    isAvailableForWork: true,
  },
  {
    id: '9',
    usersName: 'YakubuDanladi',
    firstName: 'Yakubu',
    lastName: 'Danladi',
    email: 'yakubu.danladi@example.com',
    phone: '+2348012345679',
    birthday: '1984-04-25',
    state: 'Niger',
    country: 'Nigeria',
    yearsOfExperience: 15,
    occupation: 'Health Technician',
    bio: 'Dedicated technician assisting with clinical operations.',
    profileImage: null,
    isVerified: true,
    verification: {
      id: 'v9',
      yearOfCurrentLicense: '2010',
      license: 'HT/NG/2020/2233',
      primaryDegreeName: 'Diploma in Health Tech',
      primaryDegreeCertificate: 'degree-ht.pdf',
      validationNumber: 'VAL223344',
      status: 'verified',
      updatedAt: new Date().toISOString(),
      createdAt: new Date().toISOString(),
    },
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Gold',
    governmentIdStatus: 'verified',
    isAvailableForWork: true,
  },
  {
    id: '10',
    usersName: 'AishaMohammed',
    firstName: 'Aisha',
    lastName: 'Mohammed',
    email: 'aisha.mohammed@example.com',
    phone: '+2348012345680',
    birthday: '1994-12-30',
    state: 'Borno',
    country: 'Nigeria',
    yearsOfExperience: 6,
    occupation: '(CHEW) Community Health Extension workers',
    bio: 'Community health worker dedicated to rural healthcare delivery.',
    profileImage: null,
    isVerified: false,
    verification: null,
    experiences: [],
    updatedAt: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    tier: 'Silver',
    governmentIdStatus: 'pending',
    isAvailableForWork: false,
  },
];
